import {
  SETTING_PUBLIC_PROFILE_PAGE_REQUEST,
  SETTING_PUBLIC_PROFILE_CHANGE_FORM,
  SETTING_PUBLIC_PROFILE_REQUEST,
  SETTING_PUBLIC_PROFILE_DISCARD_CHANGE,
} from './constants';

export function publicProfilePageRequest() {
  return { type: SETTING_PUBLIC_PROFILE_PAGE_REQUEST, payload: {} };
}

export function changeFormPublicProfile(profile) {
  return { type: SETTING_PUBLIC_PROFILE_CHANGE_FORM, payload: { profile } };
}

export function publicProfileRequest(data) {
  return { type: SETTING_PUBLIC_PROFILE_REQUEST, payload: { data } };
}

export function discardChange(location) {
  return { type: SETTING_PUBLIC_PROFILE_DISCARD_CHANGE, payload: { location } };
}
